// export enum DrugTypes {
// 	Synthetic = 1,
// 	Biotech = 2
// };

export enum Role {
  Administrator = 1,
  ProductManager = 2,
  RegionalManager = 3,
  Trader = 4
}

export enum Lang {
  bg = 1,
  en = 2
}

export enum OfferStatus {
  NewOffer = 1,
  Expired = 2,
  Accepted = 3,
  InExecution = 4,
  Finished = 5,
  SentToClient = 6
}

export enum UserActiveFilter {
  All = 1,
  Actives = 2,
  NotActives = 3,
}

export enum OfferSteps {
  ClientData = 1,
  TwoDPlan = 2,
  GasInstallation = 3,
  HeatingInstallation = 4,
  GenerateOffer = 5
}

export enum StepperPosition {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Fifth = 5
}

export enum BuildingType {
  Brick = 1,
  Panel = 2,
  EPK = 3,
}

export enum PipeInstallation {
  Floor = 1,
  Ceiling = 2
}

export enum Position {
  East = 1,
  West = 2,
  North = 3,
  South = 4,
  EastAndWest = 5,
  EastAndNorth = 6,
  EastAndSouth = 7,
  WestAndNorth = 8,
  WestAndSouth = 9,
  NorthAndSouth = 10,
  EastWestNorth = 11,
  EastWestSouth = 12,
  EastNorthSouth = 13,
  WestNorthSouth = 14,
  All = 15,
  Inside = 16
}

export enum IsolationType {
  None = 1,
  Inside = 2,
  Outside = 3,
  InsideAndOutside = 4
}

export enum ProductRelationTypes {
  InstallationActivity = 1,
  Fastener = 2,
  Package = 3
}

export enum Units {
  UnitNumber = 1,
  UnitLinearMeter = 2
}

export enum CategoryType {
  GasInstallation = 1,
  HeatInstallation = 2,
  Devices = 3,
  Packages = 4,
  Services = 5,
  Equipment = 6,
  Materials = 7,
  Radiators = 8,
  Labor = 9,
  Pipes = 10,
  Kits = 11,
  Cauldrons = 12,
  Stoves = 13,
  Flues = 14,
  Boilers = 15,
  TowelRails = 16,
  Convectors = 17
}

export enum InstallationProductType {
  Main = 1,
  Additional = 2
}

export enum OfferInstallationType {
  Gas = 1,
  Heath = 2
}

export enum TimePeriod {
  Month = 1,
  Quarter = 2,
  Year = 3
}

export enum FileSystemType {
  Offer = 1,
  BillOfQuantities = 2,
  AxonometricDiagramGas = 3,
  AxonometricDiagramHeat = 4,
  Installation = 5,
  ProductImage = 6,
  BillOfQuantitiesLabor = 7,
}

export enum ActionType {
  Delete = 1,
  OfferTraderChange = 2,
}

export enum PageSize {
  A0_x_4 = "4A0",
  A0_x_2 = "2A0",
  AO = "A0",
  A1 = "A1",
  A2 = "A2",
  A3 = "A3",
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
  A7 = "A7",
  A8 = "A8",
  A9 = "A9",
  A1O = "A10",
  BO = "B0",
  B1 = "B1",
  B2 = "B2",
  B3 = "B3",
  B4 = "B4",
  B5 = "B5",
  B6 = "B6",
  B7 = "B7",
  B8 = "B8",
  B9 = "B9",
  B1O = "B10",
  CO = "C0",
  C1 = "C1",
  C2 = "C2",
  C3 = "C3",
  C4 = "C4",
  C5 = "C5",
  C6 = "C6",
  C7 = "C7",
  C8 = "C8",
  C9 = "C9",
  C1O = "C10",
  RA1 = "RA1",
  RA2 = "RA2",
  RA3 = "RA3",
  RA4 = "RA4",
  SRA1 = "SRA1",
  SRA2 = "SRA2",
  SRA3 = "SRA3",
  SRA4 = "SRA4",
  EXECUTIVE = "EXECUTIVE",
  FOLIO = "FOLIO",
  LEGAL = "LEGAL",
  LETTER = "LETTER",
  TABLOID = "TABLOID"
}

export enum PageOrientation {
  PORTRAIT = "PORTRAIT",
  LANDSCAPE = "LANDSCAPE"
}